import { Component } from '@angular/core';

@Component({
  selector: 'app-news-redesign',
  templateUrl: './news-redesign.component.html',
  styleUrls: ['./news-redesign.component.scss']
})
export class NewsRedesignComponent {

}
